import { render, staticRenderFns } from "./FlawView.vue?vue&type=template&id=668ebad3&scoped=true"
import script from "./FlawView.vue?vue&type=script&lang=js"
export * from "./FlawView.vue?vue&type=script&lang=js"
import style0 from "./FlawView.vue?vue&type=style&index=0&id=668ebad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ebad3",
  null
  
)

export default component.exports